import { Users } from 'lucide-react';

export const CoopAssignment = ({ prospect }) => {
    if (!prospect.coop_mode_enabled || !prospect.can_manage_coop) return null;
    return (
        <div className="flex min-w-0 items-center gap-1.5 text-sm" data-testid="prospect-coop-assignment">
            <Users className="h-4 w-4 shrink-0 text-amber-600" />
            <span className="shrink-0 text-slate-500">Apporteur Coop :</span>
            <span className="min-w-0 break-words font-medium text-amber-800" data-testid="prospect-coop-assignee-name">
                {prospect.coop_apporteur_name || 'Apporteur indisponible'}
            </span>
        </div>
    );
};
